<template>
  <div class="main-contentMuni">
    <div class="toolbar-container">
      <ToolbarMunicipal
        views="none"
        :icons="toolbarIcons"
        @abrir-turno="abrirTurnoDesdeToolbar"
        @accion="openScheduleModal()"
        @toggle-filtros="mostrarFiltros = !mostrarFiltros"
      >
        <FiltroComponentSimplificado
          v-if="mostrarFiltros"
          seccion="turnos"
          @filtro-aplicado="aplicarFiltro"
          @filtro-limpiado="limpiarFiltro"
        />
      </ToolbarMunicipal>
    </div>
    <div class="content-container">
      <EstadisticasComponent />
    </div>
    <ModalManager
      ref="modalManagerRef"
      @closeAllUpdate="closeAllUpdate()"
      @close-clear="closeModal()"
    />
  </div>
</template>
<script setup>
import { toolbarIcons } from "@/assets/icons/toolbarIcons";
import EstadisticasComponent from "@/components/Municipal/Estadisticas/EstadisticasComponent.vue";
import FiltroComponentSimplificado from "@/components/Municipal/Filtro/FiltroComponentSimplificado.vue";
import ToolbarMunicipal from "@/components/Municipal/HomeMunicipal/Toolbar/ToolbarMunicipal.vue";
//import { onMounted, ref, watch } from "vue";
//import { useRoute, useRouter } from "vue-router";

import ModalManager from "@/components/Utils/Modales/ModalManager.vue";

/*const mostrarFiltros = ref(false);
//const ScheduleModal = ref(false);
const scheduleModalKey = ref(0);
const load = ref({});
const modalManagerRef = ref(null);
const route = useRoute();
const router = useRouter();
const turnosRef = ref(null);

const closeModal = () => {
  load.value = {};
};

function abrirTurnoPorId(id) {
  const evento = turnosRef.value?.calendarOptions?.events.find(
    (e) => e.id == id
  );
  if (evento) {
    turnosRef.value.openModal({ event: evento });
  }
}

function abrirTurnoDesdeToolbar(id) {
  abrirTurnoPorId(id);
}

// 🔹 Caso: ya estamos en /turnero y desde Notificaciones emitimos abrir-modal-con-id
function handleAbrirModal({ tipo, id }) {
  if (tipo !== "turno") return;
  const stopWatch = watch(
    () => turnosRef.value?.calendarOptions?.events,
    (eventos) => {
      if (eventos?.length) {
        abrirTurnoPorId(id);
        stopWatch();
      }
    },
    { immediate: true, deep: true }
  );
}

// 🔹 Caso: venimos redirigidos desde otra vista con ?abrir=turno&id=xxx
onMounted(() => {
  const { abrir, id } = route.query || {};
  if (abrir === "turno" && id) {
    const stopWatch = watch(
      () => turnosRef.value?.calendarOptions?.events,
      (eventos) => {
        if (eventos?.length) {
          abrirTurnoPorId(id);
          stopWatch();
        }
      },
      { immediate: true, deep: true }
    );
    router.replace({ query: {} });
  }
});

// Función para abrir el modal de Agendar Turno
const openScheduleModal = () => {
  // Accede al método 'openModal' del componente a través de la referencia
  if (modalManagerRef.value) {
    modalManagerRef.value.openModal(AgendarTurnoComponent, {
      size: "lg",
      scrollable: false,
      preLoad: load.value,
    });
  }
};*/
</script>

<style scoped>
.main-contentMuni {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.toolbar-container {
  position: relative;
  top: 0;
  z-index: 0;
  display: flex;
  align-items: center;
}

.content-container {
  overflow-y: auto;
  width: 82.03vw;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
}
</style>
